import { Bar, Line } from "react-chartjs-2";
import {
  BarElement,
  Chart as ChartJS,
  CategoryScale,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, Filler, Legend, LineElement, LinearScale, PointElement, Tooltip);

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
      labels: {
        color: "#132136",
        usePointStyle: true
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      ticks: {
        color: "#73665a"
      }
    },
    y: {
      grid: {
        color: "rgba(15, 39, 66, 0.08)"
      },
      ticks: {
        color: "#73665a"
      }
    }
  }
};

export default function Chart({ labels, datasets, options, type = "line" }) {
  const ChartComponent = type === "bar" ? Bar : Line;

  return (
    <div className="chart-frame">
      <ChartComponent
        data={{
          labels,
          datasets
        }}
        options={{
          ...defaultOptions,
          ...options
        }}
      />
    </div>
  );
}
